import '@popperjs/core';
import 'bootstrap';
import * as coreui from '@coreui/coreui-pro';
import Choices from 'choices.js';

window.coreui = coreui;
window.Choices = Choices;

window.choices_config = {
  removeItemButton: true,
    loadingText: 'Carregando...',
    noResultsText: 'Nenhum resultado encontrado',
    noChoicesText: 'Nenhuma escolha encontrada',
    itemSelectText: 'Pressione para selecionar',
    uniqueItemText: 'Somente valores únicos podem ser adicionados',
    customAddItemText: 'Somente valores com um determinado padrão podem ser adicionados',
    addItemText: (value, rawValue) => {
      return `Pressione Enter para adicionar <b>"${value}"</b>`;
    },
    removeItemIconText: () => `Remover item`,
    removeItemLabelText: (value, rawValue) => `Remover item: ${value}`,
    maxItemText: (maxItemCount) => {
      return `Somente ${maxItemCount} valores podem ser adicionados`;
    },
};

async function link_copy(url, text = "Link copiado com sucesso") {
    try {
        const root_path = window.location.origin;
        await navigator.clipboard.writeText(`${root_path}${url}`);
        alert(text);
    } catch (err) {
        alert('Erro ao copiar o link');
    }
}
window.link_copy = link_copy;

function getSelectedPrinter(eventId) {
    const saved = localStorage.getItem('printer_' + eventId);
    if (saved) {
        try {
            return JSON.parse(saved);
        } catch (e) {
            return null;
        }
    }
    return null;
}
window.getSelectedPrinter = getSelectedPrinter;

// window.htmx = require('htmx.org');
